import { render, staticRenderFns } from "./FotavInputTable.vue?vue&type=template&id=1f9a26f9&scoped=true&"
import script from "./FotavInputTable.vue?vue&type=script&lang=js&"
export * from "./FotavInputTable.vue?vue&type=script&lang=js&"
import style0 from "./FotavInputTable.vue?vue&type=style&index=0&id=1f9a26f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a26f9",
  null
  
)

export default component.exports